import React from "react";
import { io } from "socket.io-client";

const params = new URLSearchParams(window.location.search);
export const access_token = params.get('access_token'); 
export const admin_id = params.get('admin_id'); 

// const url = 'https://crash-rgs.staging-server.in';
const url = process.env.REACT_APP_CRASH_URL;
// const url = 'http://localhost:3001/';

export const socketConn = io(`${url}?access_token=${access_token}`, {
  transports: ["websocket"], // Try WebSocket first, fallback to polling
  // transports: ["websocket"],
  withCredentials: true,
  reconnectionAttempts: 2, // Number of reconnection attempts
  reconnectionDelay: 1000, // Time between reconnection attempts (ms)
  timeout: 20000, // Connection timeout
  forceNew: true, // Force a new connection
  path: "/socket.io/", // Confirm this matches your server configuration
  auth: {
    // Add any authentication if required
    // admin_id:admin_id,
    access_token: access_token
  },
});
// socket.connect();
